/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Habit } from '../../models/habit';

export interface PostHabit$Plain$Params {
  'api-version'?: string;
  
    /**
     * Habit to create
     */
    body?: Habit
}

export function postHabit$Plain(http: HttpClient, rootUrl: string, params?: PostHabit$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Habit>> {
  const rb = new RequestBuilder(rootUrl, postHabit$Plain.PATH, 'post');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Habit>;
    })
  );
}

postHabit$Plain.PATH = '/habit';
